import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as NewRoute from "./new";
import * as ListRoute from "./list";
import * as WorkflowRoute from "./workflow";
import WorkflowPublicSchema from "@common/schema/workflow/public";
import * as Section from "@repoflow/components/section";

// `Section` here is the routing/form primitive every screen in this app is
// wrapped in — the same one the keys screens use. It has nothing to do with
// pagews' entity of that name.
const LocalProvider = ({
  match: {
    params,
  },
  children: Children,
}) => {
  const base = `/workflow`;
  const basepath = `/workflow`;

  return (
    <Section.Provider
      schema={WorkflowPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:workflowId`} component={WorkflowRoute.Content} />
          <Route path={`${basepath}/`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Workflows</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/new`} component={NewRoute.Indice} />
            <Route
              path={`${basepath}/:workflowId`}
              component={WorkflowRoute.Indice}
            />
            <Route path={`${basepath}/`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
